import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, supportedLanguages } from './resources.js';
import { detectLanguage } from './detectLanguage.js';
import { formatMoowoo } from '../constants/moowoo';

const getInitialLanguage = () => {
  try {
    const stored = localStorage.getItem('myLanguage');
    if (stored) return stored;
  } catch (_) {}
  return detectLanguage(supportedLanguages);
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

i18n.services.formatter.add('moowoo', (value, lng) => {
  return formatMoowoo(value, lng);
});

export default i18n;
